import { render, staticRenderFns } from "./crm-update_class.vue?vue&type=template&id=6fb7fec6&"
import script from "./crm-update_class.vue?vue&type=script&lang=js&"
export * from "./crm-update_class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports